import * as e from "react";
const c = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10 .146C4.486.146 0 4.79 0 10.5c0 5.71 4.486 10.354 10 10.354S20 16.21 20 10.5C20 4.79 15.514.146 10 .146zm0 18.92c-4.562 0-8.273-3.843-8.273-8.566 0-4.723 3.711-8.566 8.273-8.566 4.561 0 8.273 3.843 8.273 8.566 0 4.723-3.711 8.566-8.273 8.566z",
      fill: "#2D6DED"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.037 7.193c.992 0 1.83.578 1.83 1.263 0 .52.477.941 1.066.941.59 0 1.067-.421 1.067-.941 0-1.44-1.229-2.655-2.896-3.027V4.192c0-.52-.478-.941-1.066-.941-.59 0-1.067.421-1.067.941V5.43c-1.668.372-2.896 1.586-2.896 3.027 0 1.697 1.705 3.082 3.826 3.14.02 0 .04.005.061.005 1.009 0 1.83.565 1.83 1.261 0 .684-.838 1.262-1.83 1.262-.99 0-1.83-.578-1.83-1.262 0-.52-.476-.941-1.066-.941-.589 0-1.066.42-1.066.941 0 1.461 1.265 2.69 2.97 3.04v.903c0 .52.478.942 1.067.942s1.066-.421 1.066-.942v-.933c1.63-.39 2.821-1.591 2.821-3.01 0-1.697-1.704-3.081-3.826-3.139-.02 0-.04-.005-.061-.005-.992 0-1.83-.578-1.83-1.262s.839-1.263 1.83-1.263z",
      fill: "#2D6DED"
    }
  )
);
export {
  c as default
};
